import { render, staticRenderFns } from "./tuwenhuifu.vue?vue&type=template&id=138cfa9b&scoped=true&"
import script from "./tuwenhuifu.vue?vue&type=script&lang=js&"
export * from "./tuwenhuifu.vue?vue&type=script&lang=js&"
import style0 from "./tuwenhuifu.vue?vue&type=style&index=0&id=138cfa9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cfa9b",
  null
  
)

export default component.exports